/*eslint-env node*/

const auth = {
  getTokenISAM:
    window._env_.REACT_APP_ENDPOINT_OAUTH_ISAM + "/mga/sps/oauth/oauth20/",
  logoutISAM: window._env_.REACT_APP_ENDPOINT_OAUTH_ISAM + "/pkmslogout",
  refreshTokenISAM:
    window._env_.REACT_APP_ENDPOINT_OAUTH_ISAM + "/[refreshTokenApi]",
  getTokenC_ID:
    window._env_.REACT_APP_ENDPOINT_OAUTH_C_ID +
    "/myidentity/notifier/signinorsignup",
  logoutC_ID:
    window._env_.REACT_APP_ENDPOINT_OAUTH_C_ID + "/myidentity/notifier/singout",
  refreshTokenC_ID:
    window._env_.REACT_APP_ENDPOINT_OAUTH_C_ID +
    "/myidentity/notifier/RefreshToken",
  userDataC_ID:
    window._env_.REACT_APP_ENDPOINT_OAUTH_API_C_ID + "/api/Accounts/user",
};

const back = {
  getInfoEnvio: window._env_.REACT_APP_ENDPOINT_API_COLDINTEG + "/envio/",
  getListEnvios:
    window._env_.REACT_APP_ENDPOINT_API_COLDINTEG + "/container/shipment-list",
  getShipmentInfo:
    window._env_.REACT_APP_ENDPOINT_API_COLDINTEG +
    "/container/by-shipment-code",
  fetchShipmentPod:
    window._env_.REACT_APP_ENDPOINT_API_COLDINTEG + "/container/pod",
  getAlarms:
    window._env_.REACT_APP_ENDPOINT_API_COLDINTEG + "/alarm/alarm-list",
  getParticipants:
    window._env_.REACT_APP_ENDPOINT_API_COLDINTEG + "/participants/list",
  getPagedParticipants:
    window._env_.REACT_APP_ENDPOINT_API_COLDINTEG + "/participants/page",
  addParticipant:
    window._env_.REACT_APP_ENDPOINT_API_COLDINTEG + "/participant",
  addParticipantsByFile:
    window._env_.REACT_APP_ENDPOINT_API_COLDINTEG + "/participant/bulk",
  updateParticipant:
    window._env_.REACT_APP_ENDPOINT_API_COLDINTEG + "/participant",
  deleteParticipant:
    window._env_.REACT_APP_ENDPOINT_API_COLDINTEG + "/participant",
  getPostalCode:
    window._env_.REACT_APP_ENDPOINT_API_COLDINTEG + "/postal-codes",
  getUserProfiles:
    window._env_.REACT_APP_ENDPOINT_API_COLDINTEG + "/client-info",
  getImeiInfo: window._env_.REACT_APP_ENDPOINT_API_COLDINTEG + "/imei",
  preRegister: window._env_.REACT_APP_ENDPOINT_API_COLDINTEG + "/preregister",
  preRegisterProximity:
    window._env_.REACT_APP_ENDPOINT_API_COLDINTEG + "/preregister/proximity",
  getPostalCodeRestriction:
    window._env_.REACT_APP_ENDPOINT_API_COLDINTEG +
    "/proximity-restriction/check-origin",
  massivePreRegister:
    window._env_.REACT_APP_ENDPOINT_API_COLDINTEG + "/preregister/bulk",
  getLabels: window._env_.REACT_APP_ENDPOINT_API_COLDINTEG + "/print-label",
  getReportData: window._env_.REACT_APP_ENDPOINT_API_COLDINTEG + "/report",
  getSearchOptions:
    window._env_.REACT_APP_ENDPOINT_API_COLDINTEG + "/container/filters",
  getMaterialLimits:
    window._env_.REACT_APP_ENDPOINT_API_COLDINTEG + "/material/limits",
  createMaterialRequest:
    window._env_.REACT_APP_ENDPOINT_API_COLDINTEG + "/material",
  getMaterialRequestHistory:
    window._env_.REACT_APP_ENDPOINT_API_COLDINTEG + "/material/history",
};

const authCid = {
  getAuthToken: window._env_.REACT_APP_ENDPOINT_API_C_ID + "/api/Login",
  refreshToken:
    window._env_.REACT_APP_ENDPOINT_API_C_ID + "/api/Login/RefreshToken",
  userDate: window._env_.REACT_APP_ENDPOINT_API_C_ID + "/api/ProfileUser",
  cancelToken:
    window._env_.REACT_APP_ENDPOINT_API_C_ID + "/api/Login/CancelToken",
};

module.exports = {
  auth,
  back,
  authCid,
};
